// extracted by mini-css-extract-plugin
export default {"root":"IconFinanceCoaching_root__q2vRM"};